import { __decorate } from "tslib";
import { ArrayDecoder, AutoEncoder, field, StringDecoder } from '@simonbackx/simple-encoding';
import { MembersBlob } from '../members/MemberWithRegistrationsBlob.js';
import { Payment } from '../members/Payment.js';
import { RegistrationWithTinyMember } from '../members/RegistrationWithTinyMember.js';
export class RegisterResponse extends AutoEncoder {
    payment = null;
    paymentUrl = null;
    /**
     * Data to put in a QR-code
     */
    paymentQRCode = null;
    members;
    registrations = [];
}
__decorate([
    field({ decoder: Payment, nullable: true })
], RegisterResponse.prototype, "payment", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true, version: 28 })
], RegisterResponse.prototype, "paymentUrl", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true, optional: true })
], RegisterResponse.prototype, "paymentQRCode", void 0);
__decorate([
    field({ decoder: MembersBlob })
], RegisterResponse.prototype, "members", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(RegistrationWithTinyMember), version: 19 })
], RegisterResponse.prototype, "registrations", void 0);
//# sourceMappingURL=RegisterResponse.js.map